module.exports = __webpack_public_path__ + "img/msg3.f231cffb.png";